import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { QuillModule } from 'ngx-quill';

import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

const material = [
    MatCheckboxModule,
    MatSelectModule,
    MatToolbarModule,
    MatInputModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatProgressSpinnerModule,
    MatMenuModule,
    MatDialogModule,
    MatPaginatorModule,
    MatIconModule,
    MatTooltipModule,
    MatPaginatorModule,
    MatBadgeModule
];

import {
    ZQTabGroupComponent,
    ZQTabComponent,
    LoaderComponent,
    ConfirmationDialogComponent,
    CutDownContentComponent,
    CalibrationSetLinksComponent,
    CommentComponent
} from './components';

import { CreateUseButtonComponent } from './components/actions/create-use-button/create-use-button.component';
import { CloneUsesButtonComponent } from './components/actions/clone-uses-button/clone-uses-button.component';
import { CloneUsesPopupComponent } from './components/actions/clone-uses-button/clone-uses-popup/clone-uses-popup.component';
import { ProcessSmallSpinnerComponent } from './components/process-small-spinner/process-small-spinner.component';

const components = [
    ZQTabGroupComponent,
    ZQTabComponent,
    LoaderComponent,
    ConfirmationDialogComponent,
    CreateUseButtonComponent,
    CutDownContentComponent,
    CalibrationSetLinksComponent,
    CloneUsesButtonComponent,
    CommentComponent,
    ProcessSmallSpinnerComponent
];

@NgModule({
    declarations: [...components, CloneUsesButtonComponent, CloneUsesPopupComponent, CommentComponent],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        ...material,
        BrowserAnimationsModule,
        ScrollingModule,
        QuillModule.forRoot()
    ],
    exports: [...components, ...material],
    providers: []
})
export class ZoneIQUIModule {}
